
import "./Home.css";
import Navbar from "./navbar";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Home(){


    return(
        <div id="background">

            <Navbar />

        
            <div className="homeContentsWrapper">
                <img id="logo" src={`${process.env.PUBLIC_URL}/otherPhotos/whitelogo.png`} alt="logo"></img>
                <p id="homepageText0">welcome to</p>
                <h1 id="homepageText1" >STRAY DOG PHOTOGRAPHY</h1>
                <p id="homepageText2">by Jackson Smith</p>
                <div className="homeOptions"></div>
                    <Link to = "/Gallery " className="homepagePageLink"> <button className="homepagePageButtons">gallery</button> </Link>
                    <Link to = "/about " className="homepagePageLink"> <button className="homepagePageButtons">about</button> </Link>
                    <Link to = "/contact " className="homepagePageLink"> <button className="homepagePageButtons" >contact</button> </Link> 
                </div>
        </div>
     
        
    );
}

export default Home;